<template>
  <v-sheet class="mt-5 pa-5" tile>
    <v-container>
      <v-card class="mx-auto" height="300px">
        <v-subheader>{{ $t('DASHBOARD.TASK_REPORTS') }}</v-subheader>
        <v-list dense class="pt-0">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('DASHBOARD.NEW_NOTES_24H')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.count_per_24h }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('DASHBOARD.NEW_NOTES_PER_30_DAYS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.count_per_30days }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('DASHBOARD.REJECTED_TASKS_24H')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.count_rejected_per_24h }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="text-left"
                v-text="$t('DASHBOARD.REJECTED_TASKS_PER_30_DAYS')"
              >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                >{{ info.count_rejected_per_30days }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: 'TaskReportsCard',

  props: {
    info: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
* {
  text-transform: none !important;
}
</style>
